import { Switch } from "@headlessui/react";
import { Controller } from "react-hook-form";
import { classNames } from "utils/helpers";

type ToggleType = {
  id: string;
  label?: string;
  description?: string;
  control: any;
};

export default function FormInputToggle({
  id,
  label,
  description,
  control,
}: ToggleType) {
  return (
    <Controller
      control={control}
      defaultValue=""
      name={id}
      render={({ field }) => (
        <Switch.Group as="div" className="flex items-center justify-between">
          <Switch
            checked={field.value}
            onChange={field.onChange}
            className={classNames(
              field.value ? "bg-brand-green-dark" : "bg-gray-200",
              "relative inline-flex h-5 w-10 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-0",
            )}
          >
            <span className="sr-only">Use setting</span>
            <span
              className={classNames(
                field.value ? "translate-x-5" : "translate-x-0",
                "pointer-events-none relative inline-block h-4 w-4 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out",
              )}
            >
              <span
                className={classNames(
                  field.value
                    ? "opacity-0 duration-100 ease-out"
                    : "opacity-100 duration-200 ease-in",
                  "absolute inset-0 flex h-full w-full items-center justify-center transition-opacity",
                )}
                aria-hidden="true"
              >
                <svg
                  className="h-3 w-3 text-gray-400"
                  fill="none"
                  viewBox="0 0 12 12"
                >
                  <path
                    d="M4 8l2-2m0 0l2-2M6 6L4 4m2 2l2 2"
                    stroke="currentColor"
                    strokeWidth={2}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              <span
                className={classNames(
                  field.value
                    ? "opacity-100 duration-200 ease-in"
                    : "opacity-0 duration-100 ease-out",
                  "absolute inset-0 flex h-full w-full items-center justify-center transition-opacity",
                )}
                aria-hidden="true"
              >
                <svg
                  className="h-3 w-3 text-brand-green-dark"
                  fill="currentColor"
                  viewBox="0 0 12 12"
                >
                  <path d="M3.707 5.293a1 1 0 00-1.414 1.414l1.414-1.414zM5 8l-.707.707a1 1 0 001.414 0L5 8zm4.707-3.293a1 1 0 00-1.414-1.414l1.414 1.414zm-7.414 2l2 2 1.414-1.414-2-2-1.414 1.414zm3.414 2l4-4-1.414-1.414-4 4 1.414 1.414z" />
                </svg>
              </span>
            </span>
          </Switch>
          <span className="ml-3 flex flex-grow flex-col">
            {label && (
              <Switch.Label as="span" className="text-base" passive>
                {label}
              </Switch.Label>
            )}
            {description && (
              <Switch.Description
                as="span"
                className="text-sm text-brand-green-dark"
              >
                {description}
              </Switch.Description>
            )}
          </span>
        </Switch.Group>
      )}
    />
  );
}
